<ng-container *ngIf="env.USE_TAILWIND">
    <gl-footer-template-five-cols *ngIf="env.FOOTER.ENABLE_FIVE_COLS_FOOTER"></gl-footer-template-five-cols>
    <gl-footer-stw *ngIf="!env.FOOTER.ENABLE_FIVE_COLS_FOOTER"></gl-footer-stw>
</ng-container>

<ng-container *ngIf="!env.USE_TAILWIND">
    <div
        class="block--footer-wrap"
        *ngIf="env.THEME_NAME !== themeFeature.VL"
        [ngClass]="{ 'extra-items': ridangoAuth.getLoginStatus() }">
        <gl-footer-template-gl></gl-footer-template-gl>
    </div>

    <div
        class="block--footer-wrap footer-with-pattern"
        *ngIf="env.THEME_NAME === themeFeature.VL"
        [ngClass]="{ 'extra-items': ridangoAuth.getLoginStatus() }">
        <gl-footer-template-vl></gl-footer-template-vl>
    </div>
</ng-container>
